module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 boxTarefas"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "col-md-4 boxQtde boxBorderRight"
  }, [_c('span', {
    staticClass: "valorQtde"
  }, [_vm._v(_vm._s(_vm.quantidadeMovFin))]), _c('br'), _c('label', {
    staticClass: "valorQtdeTxt",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estatistica.tarefa.labels.movFinanceira'))
    }
  })]), _c('div', {
    staticClass: "col-md-4 boxQtde boxBorderRight"
  }, [_c('span', {
    staticClass: "valorQtde"
  }, [_vm._v(_vm._s(_vm.quantidadeMovBan))]), _c('br'), _c('label', {
    staticClass: "valorQtdeTxt",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estatistica.tarefa.labels.movBancaria'))
    }
  })]), _c('div', {
    staticClass: "col-md-4 boxQtde"
  }, [_c('span', {
    staticClass: "valorQtde"
  }, [_vm._v(_vm._s(_vm.totalQuantidade))]), _c('br'), _c('label', {
    staticClass: "valorQtdeTxt",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estatistica.tarefa.labels.total'))
    }
  })])]), _c('div', {
    staticClass: "clear"
  }), (_vm.isPendentTab) ? _c('div', [_c('div', {
    staticClass: "alerta"
  }, [(_vm.data && _vm.data.quantidadeVencidas && _vm.data.quantidadeVencidas > 0) ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "badge badge-custom-tasks"
  }, [_vm._v(_vm._s(_vm.data.quantidadeVencidas))]), _c('div', {
    staticClass: "alerta-text"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.quantidadeVencidas === 1 ? _vm.$t('estatistica.tarefa.labels.alertaVencidasSingular') : _vm.$t('estatistica.tarefa.labels.alertaVencidasPlural'))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "link",
    domProps: {
      "innerHTML": _vm._s(_vm.$t("estatistica.tarefa.labels.verQuaisSao"))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.redirectToTasks(("" + _vm.naoConcluido), ("" + _vm.tipoNaoConcluido))
      }
    }
  })])]) : _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estatistica.tarefa.labels.alertaSemTarefasVencidas'))
    }
  })])]), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_c('br'), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getTextNextExpiration())
    }
  })])])])]) : _c('div', [_c('div', {
    staticClass: "alerta text-center"
  }, [(_vm.data && _vm.data.totalQuantidadeConcluida && _vm.data.totalQuantidadeConcluida > 0) ? _c('div', [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.redirectToTasks(("" + _vm.concluido), ("" + _vm.tipoConcluido))
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('estatistica.tarefa.tooltip.concluidas')))])]) : _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estatistica.tarefa.labels.semTarefasConcluidas'))
    }
  })])])]), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7b55184e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b55184e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/dashboard/gadget/taskGadgetTabContent.pug
// module id = 1444
// module chunks = 0